// extracted by mini-css-extract-plugin
export var alternate = "_18-h";
export var black = "_18-3";
export var blue = "_18-d";
export var blueLight = "_18-c";
export var brand = "_18-7";
export var error = "_18-9";
export var gray = "_18-6";
export var grayBlue = "_18-b";
export var iconWrapper = "_18-4";
export var indigo = "_18-e";
export var orange = "_18-g";
export var pink = "_18-f";
export var primary = "_18-0";
export var purple = "_18-8";
export var success = "_18-5";
export var warning = "_18-a";
export var white = "_18-1";
export var whiteSuccess = "_18-2";